import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-itsm-bfsi',
  templateUrl: './page.html',
  styleUrl: './page.scss',
  standalone: true,
  imports: [RouterModule],
})
export class BFSISolution {
  
  constructor() {}

}